import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

export type ComponentProps = RootContainerProps & {
  style: React.CSSProperties;
};

export default (props: ComponentProps) => (
  <Container {...getContainerProps(props)}>
    <div style={{ flex: 1 }}>
      <div style={props.style} />
    </div>
  </Container>
);
